import { MatButtonModule, MatProgressSpinnerModule } from '@angular/material';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from './../../shared/shared.module';

import { TransactionHistoryService } from './transaction-history.service';

import { TransactionPendingComponent } from './transaction-pending/transaction-pending.component';
import { TransactionHistoryComponent } from './transaction-history.component';
import { TransactionSummaryComponent } from './transaction-summary/transaction-summary.component';
import { LastTransactionsComponent } from './last-transactions/last-transactions.component';
import { TransactionResultComponent } from './transaction-result/transaction-result.component';
import { ModalWarningComponent } from './modal-warning/modal-warning.component';
import { TransactionScheduledComponent } from './transaction-scheduled/transaction-scheduled.component';



@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		FormsModule,
		ReactiveFormsModule
	],
	declarations: [
		TransactionPendingComponent,
		TransactionHistoryComponent,
		TransactionSummaryComponent,
		LastTransactionsComponent,
		TransactionResultComponent,
		ModalWarningComponent,
		TransactionScheduledComponent
	],
	providers: [TransactionHistoryService]
})
export class TransactionHistoryModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transaction-history/transaction-history.module.ts